// Components
import SkeletonTopCategories from "components/molecules/SkeletonTopCategories";
import TopNavigationMobile from "components/organisms/TopNavigationMobile";

// Hooks
import { useLoaderStore } from "stores/loader";

const TopNavigationMobileContainer = () => {
  const { overlayLoading } = useLoaderStore();
  if (overlayLoading) {
    return <SkeletonTopCategories />;
  }
  return <TopNavigationMobile />;
};

export default TopNavigationMobileContainer;
